import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TruckOutlinedSvg from "@ant-design/icons-svg/es/asn/TruckOutlined";
import AntdIcon from '../components/AntdIcon';
var TruckOutlined = function TruckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: TruckOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(TruckOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TruckOutlined';
}
export default RefIcon;